// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"MdsCalculator_tooltip__1rgCN","tooltipText":"MdsCalculator_tooltipText__2h3c5"};